import { getMaskedNumber } from "../../Utils/Constants/MaskedNumber";

export enum localStorageConstants {
  vuaId = "vuaId",
  refreshToken = "refresh-token",
  phoneNumber = "phoneNumber",
  accessToken = "access-token",
  UserId = "userid",
  SessionId = "sessionid",
  Redirect = "redirect",
  SrcRef = "srcref",
  TxnId = "txnid",
  FiuId = "fiuId",
}

export function setAccessToken(accessToken: string) {
  localStorage.setItem(localStorageConstants.accessToken, accessToken);
}

export function setPhoneNumber(phoneNumber: string) {
  localStorage.setItem(localStorageConstants.phoneNumber, phoneNumber);
}

export function setRefreshToken(refreshToken: string) {
  localStorage.setItem(localStorageConstants.refreshToken, refreshToken);
}

export function setVuaId(vuaId: string) {
  localStorage.setItem(localStorageConstants.vuaId, vuaId);
}

export function getLocalStorageItem(item: string) {
  return localStorage.getItem(item);
}

export function setCredentialsLocalStorage(res: any) {
  setAccessToken(res.access_token);
  setPhoneNumber(getMaskedNumber(res.phoneNumber));
  setRefreshToken(res.refresh_token);
  setVuaId(res.vuaId);
}

export function setUserId(userId: string) {
  localStorage.setItem(localStorageConstants.UserId, userId);
}

export function setSessionId(sessionId: string) {
  localStorage.setItem(localStorageConstants.SessionId, sessionId);
}

export function setRedirect(redirect: string) {
  localStorage.setItem(localStorageConstants.Redirect, redirect);
}

export function setSrcRef(srcRef: string) {
  localStorage.setItem(localStorageConstants.SrcRef, srcRef);
}

export function setTxnId(txnId: string) {
  localStorage.setItem(localStorageConstants.TxnId, txnId);
}

export function setFiuId(fiuId: string) {
  localStorage.setItem(localStorageConstants.FiuId, fiuId);
}

export function setDecryptedCredential(res: any) {
  setUserId(res.userid);
  setRedirect(res.redirect);
  setSrcRef(res.srcref);
  setSessionId(res.sessionid);
  setTxnId(res.txnid);
  setFiuId(res.fiuId);
}
